import { Component, EventEmitter, Input, Output, HostListener, AfterViewInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { EluxButton, EluxIcon } from '@elxjs/ui'

@Component({
  selector: 'app-footer-bar',
  standalone: true,
  imports: [EluxIcon, RouterModule, EluxButton],
  templateUrl: './footer-bar.component.html',
  styleUrls: ['./footer-bar.component.scss'],
})
export class FooterBarComponent implements AfterViewInit {
  @Input() backUrl = ''
  @Input() backQueryParams: Record<string, any> | null = null
  @Input() backText = ''
  @Output() backEvent = new EventEmitter<void>()
  @Input() nextText = ''
  @Input() nextDisabled = false
  @Input() nextLoading = false
  @Output() nextEvent = new EventEmitter<void>()
  @Input() draftText = ''
  @Input() draftLoading = false
  @Output() draftEvent = new EventEmitter<void>()

  hasShadow = false

  ngAfterViewInit() {
    this.hasShadowFn()
  }

  @HostListener('window:scroll')
  onScroll() {
    this.hasShadowFn()
  }

  hasShadowFn() {
    const scrollTop = window.scrollY
    const windowHeight = window.innerHeight
    const docHeight = document.documentElement.scrollHeight - 20

    this.hasShadow = scrollTop + windowHeight < docHeight - 1
    return this.hasShadow
  }
}
